export const getAltForNft = (
  collectionName: string,
  tokenId: string
): string => {
  return `nft image: collection ${collectionName} - token id ${tokenId}`;
};
